import {
  DEFAULT_HEADING_LEVEL,
  clampHeadingLevel,
  headingLevelContext,
  i as i3,
  s
} from "./chunk.N6SQZYGL.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i as i2
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  i
} from "./chunk.775UL347.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-heading/jb-heading-context.ts
var JbHeadingContext = class extends i2 {
  constructor() {
    super(...arguments);
    this.offset = 0;
    this._inheritedLevel = new s(this, {
      context: headingLevelContext,
      subscribe: true
    });
    this._provider = new i3(this, {
      context: headingLevelContext,
      initialValue: DEFAULT_HEADING_LEVEL
    });
  }
  willUpdate() {
    const inheritedLevel = this._inheritedLevel.value ?? DEFAULT_HEADING_LEVEL;
    const level = this.rank ?? inheritedLevel + (this.offset ?? 0);
    this._provider.setValue(clampHeadingLevel(level));
  }
  render() {
    return b`<slot></slot>`;
  }
};
JbHeadingContext.styles = i`
    :host {
      display: contents;
    }
  `;
__decorateClass([
  n({ type: Number })
], JbHeadingContext.prototype, "offset", 2);
__decorateClass([
  n({ type: Number })
], JbHeadingContext.prototype, "rank", 2);
JbHeadingContext = __decorateClass([
  customElement("jb-heading-context")
], JbHeadingContext);

export {
  JbHeadingContext
};
